import type { PluginTypeEnumTypes } from "@chat-ai/_database/enums";

// Plugin metadata
export const pluginsMetadata = (
  pluginType: PluginTypeEnumTypes | undefined,
): {
  type: PluginTypeEnumTypes;
  name: string;
  description: string;
  examplePrompt: string;
  order: number;
  adminOnly: boolean;
  metricColor: string;
  hasConfig: boolean;
} => {
  switch (pluginType) {
    case "WEBREADER":
      return {
        type: "WEBREADER",
        name: "Web",
        description: "Search the web for current information",
        examplePrompt: "Latest news about LEO Pharma",
        order: 1,
        adminOnly: false,
        metricColor: "var(--brand-tl-red-500)",
        hasConfig: false,
      };
    case "DALL_E":
      return {
        type: "DALL_E",
        name: "Image Generator",
        description: "Generate images",
        examplePrompt: "Generate an image of a cat",
        order: 2,
        adminOnly: false,
        metricColor: "var(--brand-tl-yellow-500)",
        hasConfig: false,
      };
    case "CODE_INTERPRETER":
      return {
        type: "CODE_INTERPRETER",
        name: "Code Interpreter",
        description: "Run code in various programming languages",
        examplePrompt: "Create graph of normal distribution",
        order: 3,
        adminOnly: false,
        metricColor: "var(--brand-tl-green-500)",
        hasConfig: false,
      };
    case "MS_OFFICE_WRITER":
      return {
        type: "MS_OFFICE_WRITER",
        name: "Document Generator",
        description: "Create a document in Microsoft Word/Powerpoint",
        examplePrompt: "Create a document in Microsoft Word",
        order: 4,
        adminOnly: false,
        metricColor: "var(--brand-ter-blue-500)",
        hasConfig: false,
      };
    case "RESEARCH_AI":
      return {
        type: "RESEARCH_AI",
        name: "Deep Research",
        description:
          "Conduct comprehensive research tasks using advanced web search",
        examplePrompt: "Research the latest developments in mRNA vaccines",
        order: 5,
        adminOnly: false,
        metricColor: "var(--brand-ter-bluegray-500)",
        hasConfig: false,
      };
    case "CLINICAL_TRIALS_GOV":
      return {
        type: "CLINICAL_TRIALS_GOV",
        name: "ClinicalTrials.gov",
        description: "Search for clinical trials on ClinicalTrials.gov",
        examplePrompt: "Find latest clinical trials related to Adtralza",
        order: 6,
        adminOnly: false,
        metricColor: "var(--brand-ter-green-500)",
        hasConfig: false,
      };
    case "PUBMED":
      return {
        type: "PUBMED",
        name: "PubMed",
        description: "Search for articles on PubMed",
        examplePrompt: "Find articles related to Adtralza",
        order: 7,
        adminOnly: false,
        metricColor: "var(--brand-ter-blue-400)",
        hasConfig: false,
      };
    case "SHAREPOINT":
      return {
        type: "SHAREPOINT",
        name: "OneDrive Search",
        description: "Access and search files on SharePoint",
        examplePrompt: "Search files in my SharePoint documents",
        order: 8,
        adminOnly: false,
        metricColor: "var(--brand-ter-bluegray-400)",
        hasConfig: false,
      };
    case "ISEARCH":
      return {
        type: "ISEARCH",
        name: "iSearch",
        description: "Search for information in iSearch",
        examplePrompt: "Find documents related to Adtralza",
        order: 9,
        adminOnly: false,
        metricColor: "var(--brand-ter-green-400)",
        hasConfig: true,
      };
    case "SF_SALES_INTELLIGENCE":
      return {
        type: "SF_SALES_INTELLIGENCE",
        name: "Sales Intelligence Analyst",
        description: "Access sales intelligence data in Snowflake",
        examplePrompt: "",
        order: 10,
        adminOnly: false,
        metricColor: "var(--brand-ter-blue-300)",
        hasConfig: false,
      };
    case "MEDDRA":
      return {
        type: "MEDDRA",
        name: "MedDRA",
        description:
          "Search and classify medical terms using MedDRA terminology",
        examplePrompt: "Classify the adverse event: patient experienced nausea",
        order: 10,
        adminOnly: false,
        metricColor: "var(--brand-ter-gray-500)",
        hasConfig: false,
      };
    case "HAS_DATABASE":
      return {
        type: "HAS_DATABASE",
        name: "HAS Database",
        description:
          "Search French drug evaluations (SMR/ASMR) from Haute Autorité de Santé",
        examplePrompt: "Find SMR rating for efavirenz",
        order: 11,
        adminOnly: false,
        metricColor: "var(--brand-ter-gray-400)",
        hasConfig: false,
      };
    case "SERVICE_NOW_KNOWLEDGE_ARTICLES":
      return {
        type: "SERVICE_NOW_KNOWLEDGE_ARTICLES",
        name: "Service Now",
        description: "Search knowledge articles in ServiceNow",
        examplePrompt: "How to reset my password?",
        order: 99,
        adminOnly: true,
        metricColor: "var(--brand-ter-gray-300)",
        hasConfig: false,
      };

    default:
      console.error(`Unknown plugin type: ${pluginType}`);

      return {
        type: "DALL_E",
        name: "Unknown",
        description: "Unknown plugin type",
        examplePrompt: "",
        order: 99,
        adminOnly: false,
        metricColor: "",
        hasConfig: false,
      };
  }
};
